import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { useTheme } from '@material-ui/styles'
import { veloraSelectStyles } from '../../../config/react-select-styles'
import { veloraSelectComponents } from '../../../config/react-select-components'

// react-select con los estilos de los inputs del tema y el color del cliente. Sirve también en
// componentes de clase, que no pueden llamar a useTheme. `styles` se fusiona por clave encima.
const VeloraSelect = ({ styles, components, ...rest }) => {
  const theme = useTheme()
  return <Select {...rest} components={{ ...veloraSelectComponents, ...components }} styles={veloraSelectStyles(theme.primary, styles)} />
}

VeloraSelect.propTypes = {
  styles: PropTypes.object,
  components: PropTypes.object
}

export default VeloraSelect
